import { app } from '../../app.module'
class PostTablePictureComponentCtrl {
  private mdDialog: {
    confirm: Function
    show: Function
  }
  private snsType: string
  private accountId: number
  private postId: number
  private postType: string
  private thumbnailUrl: string
  private imageShow: string
  private postLinkUrl: string
  private totalMedia: number

  constructor(
    $scope,
    $mdDialog,
    private $state
  ) {
    this.mdDialog = $mdDialog
  }

  /**
   * 初期化
   */
  public $onInit(): void {
    // twitterの場合、画像URLの後に:thumbを追加
    if (this.snsType === 'twitter' && this.thumbnailUrl !== '' && this.thumbnailUrl !== null) {
      this.imageShow = `${this.thumbnailUrl}:thumb`
    } else {
      this.imageShow = this.thumbnailUrl
    }
  }

  /**
   * LightboxModalを開く
   */
  public openLightboxModal() {
    let postType = this.postType

    // youtubeの場合、投稿タイプをvideoにセット
    if (this.snsType === 'youtube') {
      postType = 'video'
    }
    // モーダルのテンプレート
    const template = `<lightbox-modal sns-type="${this.snsType}" account-id="${this.accountId}" post-id="${this.postId}" post-type="${postType}" thumbnail-url="${this.thumbnailUrl}" post-link-url="${this.postLinkUrl}" total-media="${this.totalMedia}"></lightbox-modal>`
    const confirm = this.mdDialog
      .confirm({
        template: template,
        clickOutsideToClose: true,
      })
      .ariaLabel('lightbox')
    this.mdDialog.show(confirm)
  }
}

app.component('postTablePicture', {
  bindings: {
    snsType: '@',
    accountId: '=',
    postId: '=',
    postType: '=',
    postLinkUrl: '=',
    thumbnailUrl: '=',
    videoViews: '=',
    isModal: '=',
    totalMedia: '=',
  },
  template: require('./post-table-picture.pug')(),
  controller: PostTablePictureComponentCtrl,
})
